import { ModalMotivosPage } from "./../modal-motivos/modal-motivos";
import { Component } from "@angular/core";
import {
  IonicPage,
  Popover,
  PopoverController,
  LoadingController,
  ModalController,
  Modal,
  ToastController,
  ActionSheetController,
  Events,
  Nav,
  App,
} from "ionic-angular";
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { APIOnLine } from "../../services/api/api.services";
import { NgForm } from "@angular/forms/src/directives/ng_form";
import { ModalRecibiPage } from "../modal-recibi/modal-recibi";
import { PaginaBasica } from "../../models/PaginaBase";
import { Proxy } from "../../services/proxy/proxy.service";
import { iConfiguracion } from "../../models/basePage";
import { NuevoMenuDerechoComponent } from "../../components/nuevo-menu-derecho/nuevo-menu-derecho";
import * as modCF from '../../models/online/cfutbol';
import {
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';
import { ProyectoGanarService } from "../../services/api/ganar.services";
import { ParticipacionPage } from "../participacion/participacion";
import { CambiosPage } from "../cambios/cambios";
import { FinalizarPage } from "../finalizar/finalizar";

export interface iEstado {
  id: number;
  nombre: string;
}

@IonicPage()
@Component({
  selector: "page-resultado",
  templateUrl: "resultado.html",
})
export class ResultadoPage extends PaginaBasica {

  // #region Propiedades del controlador
  public custodia: Proxy.PrActasCustodia;
  public designacion: Proxy.PrDesignaciones;
  public estado: string = "";
  public Estados: Array<iEstado> = [
    {
      id: 1,
      nombre: "sin iniciarse",
    },
    {
      id: 2,
      nombre: "disputado",
    },
    {
      id: 3,
      nombre: "suspendido no iniciado",
    },
    {
      id: 4,
      nombre: "suspendido iniciado",
    },
  ];
  private conCustodia: boolean = true;

  private mostrarMotivosSuspensionNoIniciado: boolean = false;
  private nav: Nav;
  // #endregion

  // #region Propiedades relacionadas con el proyecto Ganar
  private activarProyectoGanar: boolean = false;    // Utilizo este 'flag' porque necesito que se muestre y oculte la capa donde está el formulario del Proyecto Ganar, porque si no se queda colgado el formulario al volver a activarlo.
  public formPG: FormGroup;
  // #endregion

  constructor(
    public appCtrl: App,
    public actionSheetCtrl: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public events: Events,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public Persistentes: APIOnLine.Persistentes,
    public proyectoGanarService: ProyectoGanarService,
    public popOverCtrl: PopoverController,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
    this.nav = this.appCtrl.getRootNav();
  }

  ionViewDidLoad() {

    this.designacion = this.Persistentes.GetDesignacion();
    this.custodia = new Proxy.PrActasCustodia(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes
    );

    // Resultado del partido (para guardarlo en los datos persistentes)
    let DatosResultado: Proxy.PrResultado = new Proxy.PrResultado(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.toastCtrl,
      this.designacion
    );

    // Inicialización de los datos del Proyecto Ganar
    if (this.designacion.Configuracion.proyectoGanar) {
      this.activarProyectoGanar = false;
      this.inicializarProyectoGanar();
    }

    this.MostrarOcultarCarga(false, "cargando datos");

    this.Persistentes.GetConfiguracion()
      .then((resultado: iConfiguracion) => {
        if (!resultado.custodia) {
          this.conCustodia = false;
        }
        if (resultado.internas.motivosSuspensionNoIniciado != undefined) {
          // Comprueba si la aplicación debe mostrar la ventana emergente que debe mostrar el listado de los motivos de suspensión
          this.mostrarMotivosSuspensionNoIniciado =
            resultado.internas.motivosSuspensionNoIniciado;
        }
        return DatosResultado.Obtener();
      })
      .then((resultado: boolean) => {
        this.Persistentes.SetGolesLocal(DatosResultado.golesLocales);
        this.Persistentes.SetGolesVisitante(DatosResultado.golesVisitantes);
        this.events.publish("cabecera:actualizarResultado");
        this.MostrarOcultarCarga();

        if (this.conCustodia) {
          this.CargarCustodia();
        }
      })
      .catch((error) =>
        this.Error(error, "Inicializando los datos de la página de Resultado.")
      );
  }

  //#region Métodos del controlador

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(NuevoMenuDerechoComponent);

    popover.present({
      ev: event,
    });
  }

  public Actualizar(form: NgForm): void {
    if (form.valid) {
      this.designacion.OtrosDatos.Guardar()
        .then((resultado: boolean) => {
          this.Mensaje(
            "Se han actualizado correctamente los datos de comienzo, final y fuerza pública.",
            5000
          );
        })
        .catch((error) =>
          this.Error(error, "ERROR actualizando los datos del acta. ")
        );
    }
  }

  public ActualizarEstado(valor: iEstado): void {
    if (this.designacion != null && this.designacion.OtrosDatos != null) {
      // Se comprueba si está activa la configuración de motivos de suspensión no iniciado, para mostrar la ventana emergente correspondiente
      if (this.mostrarMotivosSuspensionNoIniciado && valor.id == 3) {
        // Obtención de la lista de estados posibles
        this.designacion.OtrosDatos.ListaMotivosSuspension()
          .then((resultado: string[]) => {
            let modal: Modal = this.modalCtrl.create(ModalMotivosPage, {
              motivos: resultado,
            });

            modal.onDidDismiss((data: string) => {
              if (data != undefined) {
                console.log("Motivo de suspensión: " + data);

                // Guardado del motivo en la instancia correspondiente
                this.designacion.OtrosDatos.motivoSuspendidoNoIniciado = data;
                this.ActualizarEstadoSegundoPaso(valor);
              } else {
                this.designacion.OtrosDatos.idEstadoProvisional = 1;
              }
            });

            modal.present();
          })
          .catch((error) =>
            this.Error(
              error,
              "ERROR al obtener la lista de posibles motivos de suspensión"
            )
          );
      } else {
        this.ActualizarEstadoSegundoPaso(valor);
      }
    }
  }

  private ActualizarEstadoSegundoPaso(valor: iEstado): void {
    this.designacion.OtrosDatos.idEstadoProvisional = valor.id;
    this.designacion.OtrosDatos.estadoProvisional = valor.nombre;
    this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
    this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

    // Se vuelve a cambiar la configuración de las alineaciones terminadas, para que no haya problema en la desactivación de los botones de la página Home
    if (valor.id != 1) {
      this.designacion.OtrosDatos.alineacionesTerminadas = true;
    }

    this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
    this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

    this.designacion.OtrosDatos.Guardar()
      .then((resultado: boolean) => {
        this.Mensaje(
          "Se ha actualizado correctamente el estado de la designación a " +
          this.designacion.OtrosDatos.estadoProvisional,
          6000
        );
        this.Persistentes.SetDesignacion(this.designacion);
        this.events.publish("cabecera:cambioEstado");
      })
      .catch((error) =>
        this.Error(error, "ERROR al guardar el estado de la designación")
      );
  }

  /**
   * Carga los datos de la custodia asociada a la designación.
   */
  private CargarCustodia(): void {
    this.MostrarOcultarCarga(false, "cargando custodia");

    this.custodia
      .CustodiaPorDesignacion(
        this.designacion.urlApi,
        this.designacion.idDesignacion
      )
      .then((resultado: Proxy.PrActasCustodia) => {
        this.custodia = resultado;

        // Se comprueba si ya el dispositivo ha sido recibido
        if (this.custodia.NoHaSidoRecibida()) {
          let modal: Modal = this.modalCtrl.create(ModalRecibiPage, {
            custodia: resultado,
          });
          modal.onDidDismiss((data: Proxy.PrActasCustodia) => {
            // Guarda la información de la custodia
            this.custodia = data;
            this.custodia
              .Guardar(true)
              .then((resultado: Proxy.PrActasCustodia) => {
                this.Mensaje(
                  "Datos del RECIBÍ de la custodia guardados correctamente",
                  6000
                );
              })
              .catch((error) =>
                this.Error(
                  error,
                  "ERROR al guardar los datos del recibí de la CUSTODIA"
                )
              );
          });
          modal.present();
        }

        this.MostrarOcultarCarga();
      })
      .catch((error) =>
        this.Error(error, "Inicializando los datos de la custodia.")
      );
  }

  public ClaseEstado(): string {
    return this.designacion.OtrosDatos.estadoProvisional.toLowerCase().replace(" ", "-");
  }

  public GuardarMotivoSuspension(form: NgForm): void {
    if (form.valid) {
      this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
      this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

      this.designacion.OtrosDatos.Guardar()
        .then((resultado: boolean) => {
          this.Mensaje(
            "Se ha actualizado el motivo de la suspensión del partido.",
            5000
          );
        })
        .catch((error) =>
          this.Error(error, "ERROR al guardar el motivo de la suspensión.")
        );
    }
  }

  siguiente(): void {
    this.activarProyectoGanar = false;
    this.ComprobarSuspension();
  }

  /**
     * Comprueba si se ha indicado que es un partido suspendido, por lo que se debe haber indicado un motivo de dicha suspensión.
     *
     * Una vez comprobado ese hecho, si está activada la opción correspondiente, llama al método de ComprobarProyectoGanar para ver si también se cumplen esos datos.
     */
  private ComprobarSuspension(): void {
    let designacion: Proxy.PrDesignaciones =
      this.Persistentes.GetDesignacion();

    if (
      (designacion.OtrosDatos.idEstadoProvisional == 3 ||
        designacion.OtrosDatos.idEstadoProvisional == 4) &&
      designacion.OtrosDatos.motivoSuspension.trim().length == 0
    ) {
      let toast = this.toastCtrl.create({
        message:
          "Es necesario que indique el motivo de la suspensión del partido",
        duration: 6000,
      });
      toast.present();
    } else {
      this.Persistentes.SetIdEquipo(designacion.idLocal);

      if (designacion.Configuracion.proyectoGanar) {
        this.ComprobarProyectoGanar(designacion);
      } else {
        this.ComprobarSuspension_Paso2(designacion);
      }
    }
  }

  private ComprobarSuspension_Paso2(designacion: Proxy.PrDesignaciones): void {
    if (
      designacion.OtrosDatos.idEstadoProvisional == 2 ||
      designacion.OtrosDatos.idEstadoProvisional == 4
    ) {
      if (
        designacion.Configuracion.esFutbolSala ||
        designacion.Configuracion.esFutbolPlaya ||
        designacion.Configuracion.obligadaParticipacion
      ) {
        this.nav.push(ParticipacionPage);
      } else {
        this.nav.push(CambiosPage);
      }
    } else if (designacion.OtrosDatos.idEstadoProvisional == 3) {
      this.nav.push(FinalizarPage);
    }
  }

  /**
   * Comprueba si se cumplen las condiciones del Proyecto Ganar
   */
  private ComprobarProyectoGanar(designacion: Proxy.PrDesignaciones): void {
    this.proyectoGanarService.obtener(designacion.urlApi, designacion.idDesignacion)
      .subscribe({
        next: (resultado: modCF.Online.ProyectoGanar) => {
          if (resultado == null || resultado.id == 0) {
            let toast = this.toastCtrl.create({
              message:
                "Es necesario que indique los datos del PROYECTO GANAR",
              duration: 6000,
            });
            toast.present();

            this.inicializarProyectoGanar();

          } else {
            this.ComprobarSuspension_Paso2(designacion);
          }
        }
      });
  }

  //#endregion

  // #region Métodos relacionados con la información del Proyecto Ganar

  guardarProyectoGanar(form: FormGroup): void {
    if (form.valid) {
      this.proyectoGanarService.datos.observaciones = form.controls['comentarios'].value;
      this.proyectoGanarService.guardar(this.designacion.urlApi)
        .subscribe({
          next: (resultado: modCF.Online.ProyectoGanar) => {
            if (resultado != null && resultado.id > 0) {
              this.Mensaje("Se han guardado los datos relacionados con el Proyecto Ganar", 5000);
            }
          }
        });
    } else {
      this.Error("Los datos del formulario no son válidos", "PROYECTO GANAR")
    }
  }

  /**
   * Realiza el proceso de inicialización del proyecto ganar.
   */
  inicializarProyectoGanar(): void {
    this.proyectoGanarService.obtener(this.designacion.urlApi, this.designacion.idDesignacion)
      .subscribe({
        next: (resultado: modCF.Online.ProyectoGanar) => {
          this.activarProyectoGanar = true;

          if (resultado == null) {
            this.proyectoGanarService.inicializar(this.designacion);
          }

          this.formPG = new FormGroup({
            activarProtocolo: new FormControl(this.proyectoGanarService.datos.activadoProtocolo, [Validators.required]),
            situacionReconducida: new FormControl(this.proyectoGanarService.datos.situacionReconducida, [Validators.required]),
            comentarios: new FormControl(this.proyectoGanarService.datos.observaciones)
          });
        }
      });
  }

  /**
   * Indica si se debe mostrar el formulario del proyecto ganar.
   * @returns Booleano
   */
  mostrarProyectoGanar(): boolean {
    if (this.designacion != null && this.designacion.Configuracion.proyectoGanar && this.designacion.OtrosDatos.idEstadoProvisional != 1 && this.activarProyectoGanar) {
      return true;
    } else {
      return false;
    }
  }

  protocoloActivado(valor: boolean): void {
    this.proyectoGanarService.datos.activadoProtocolo = valor;
  }

  situacionActualizada(valor: boolean): void {
    this.proyectoGanarService.datos.situacionReconducida = valor;
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/resultado/resultado.ts